import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { environment } from "environments/environment";
import * as moment from "moment";
import { InscriptionService } from "app/service/inscription.service";

@Component({
  selector: "app-accueil",
  templateUrl: "./accueil.component.html",
  styleUrls: ["./accueil.component.css"],
})
export class AccueilComponent implements OnInit {
  public dateStartPreinscription = /*"2026-09-08 12:30:00";*/ "2026-10-16 12:30:00";
  public dateStopPreinscription = "2026-11-06 23:59:59";
  public isOpenPreinscription = false;
  public limitPreinscription = environment.nbLimitPreInscription;
  public limitTotal = environment.nbLimitTotalInscription;
  public limitAchieved = false;
  @ViewChild("tabsContentRef", { read: ElementRef }) tabsContentRef: ElementRef;

  constructor(private inscriptionService: InscriptionService) {}

  async ngOnInit() {
    const inscriptionsEnLigne: any = await this.inscriptionService
      .getNbPreInscriptions()
      .toPromise();
    const inscriptionsTotal: any = await this.inscriptionService
      .getNbPreInscriptionsTotal()
      .toPromise();
    if (
      inscriptionsEnLigne.length >= this.limitPreinscription ||
      inscriptionsTotal.length >= this.limitTotal
    ) {
      this.limitAchieved = true;
    } else {
      this.limitAchieved = false;
    }
    const now = moment();

    const startPreinscription = moment(
      this.dateStartPreinscription,
      "YYYY-MM-DD HH:mm:ss",
    );

    const stopPreinscription = moment(
      this.dateStopPreinscription,
      "YYYY-MM-DD HH:mm:ss",
    );

    this.isOpenPreinscription =
      now.isSameOrAfter(startPreinscription) &&
      now.isSameOrBefore(stopPreinscription);
  }

  accessPreinscription() {
    window.scroll({ top: 2000, left: 0 });
  }
}
